import { API_BASE } from '@/lib/api-client';

/**
 * Initiates Microsoft OAuth login flow (redirect-based).
 * Redirects user to backend, which redirects to Microsoft, then back to our /auth/complete page.
 */
export async function initiateMicrosoftSSO(): Promise<void> {
  const callbackUrl = `${window.location.origin}/auth/complete`;
  const loginUrl = `${API_BASE}/auth/azure/login?callbackUrl=${encodeURIComponent(callbackUrl)}`;

  const res = await fetch(loginUrl);
  if (!res.ok) {
    throw new Error('Failed to initiate Microsoft login');
  }

  const data = (await res.json()) as { authorizationUrl?: string };
  if (!data.authorizationUrl) {
    throw new Error('No authorization URL received');
  }

  window.location.href = data.authorizationUrl;
}
